/* eslint-disable global-require */
import angular from 'angular';
import OpportunityFormController from './opportunity-form.controller';

export default angular.module('autoboard.formOpportunity', [])
  .directive('formOpportunity', () => {
    'ngInject';

    return {
      controller: OpportunityFormController,
      controllerAs: '$ctrl',
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./opportunity-form.template.html'),
    };
  })
  .name;
